import React, { useContext, useMemo } from 'react';
import { Language } from '@yleisradio/areena-types';
import { Mode } from '../../../common/types';
import { ApplicationResolution } from '../../applicationResolution';
import { Device } from '../../appTypings';

export type Features = {
  applicationResolution: ApplicationResolution;
  e2eTests: boolean;
  device?: Device;
  hostname?: string;
  languageCode: Language;
  mode: Mode;
  remSize: number;
  version: string;
  muxKeyProduction: string | undefined;
  brazeApiKey: string | undefined;
};

export const defaultAppFeatures: Features = {
  languageCode: 'fi',
  mode: 'webos',
  applicationResolution: ApplicationResolution.HD,
  e2eTests: false,
  remSize: 16,
  version: 'default',
  muxKeyProduction: undefined,
  brazeApiKey: undefined,
};

export const AppFeaturesContext =
  React.createContext<Features>(defaultAppFeatures);

export const AppFeaturesContextProvider: React.FC<
  React.PropsWithChildren<Features>
> = props => {
  const {
    children,
    applicationResolution,
    e2eTests,
    device,
    hostname,
    languageCode,
    mode,
    remSize,
    version,
    muxKeyProduction,
    brazeApiKey,
  } = props;

  const value = useMemo<Features>(
    () => ({
      applicationResolution,
      e2eTests,
      device,
      hostname,
      languageCode,
      mode,
      remSize,
      version,
      muxKeyProduction,
      brazeApiKey,
    }),
    [
      applicationResolution,
      e2eTests,
      device,
      hostname,
      languageCode,
      mode,
      remSize,
      version,
      muxKeyProduction,
      brazeApiKey,
    ]
  );

  return (
    <AppFeaturesContext.Provider value={value}>
      {children}
    </AppFeaturesContext.Provider>
  );
};

export const useAppFeaturesContext = () => {
  return useContext(AppFeaturesContext);
};
